import React from 'react'

export default function InfoResignsEmployeePage() {
  return <div>ResignsEmployeePage</div>
}
